export function initLeadPopup() {

    setTimeout(() => {

        const popup = document.getElementById("leadPopup");
        const closeBtn = document.getElementById("leadClose");

        if (!popup || !closeBtn) return;

        function openPopup() {
            popup.classList.add("show");
        }

        function closePopup() {
            popup.classList.remove("show");
        }

        // open first time
        setTimeout(openPopup, 800);

        // close button
        closeBtn.onclick = closePopup;

        // reopen every 2 min
        setInterval(openPopup, 120000);

    }, 300); // wait for React render
}
